module.exports = __webpack_public_path__ + "static/images/y_person.ea30667.png";